import React from 'react'
import { NavDropdown, Nav } from 'react-bootstrap'
import { PersonFill } from 'react-bootstrap-icons'
import useCurrentUser from '../../../hooks/use-current-user'
import { useAuth0 } from '@auth0/auth0-react'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import { LinkContainer } from 'react-router-bootstrap'

const UserDropdownMenu = () => {
    const { loginWithRedirect, logout } = useAuth0()
    const { currentUser } = useCurrentUser()

    if(!currentUser) {
        return (
            <Nav.Link href='#' onClick={loginWithRedirect}>Sign In</Nav.Link>
        )
    }
    return (
        <React.Fragment>
            <NavDropdown title={<PersonFill />} alignRight>
                <LinkContainer to={CLIENT_ENDPOINTS.PROFILE}>
                    <NavDropdown.Item>
                        {currentUser ? currentUser.email : 'UNKNOWN'}
                    </NavDropdown.Item>                  
                </LinkContainer>

                <NavDropdown.Divider />
                {currentUser && <NavDropdown.Item onClick={() => logout({ returnTo: window.location.origin })}>Sign Out</NavDropdown.Item>}
            </NavDropdown>
        </React.Fragment>
    )
}

export default UserDropdownMenu